import { render, staticRenderFns } from "./selectMember.vue?vue&type=template&id=3b96e50a&scoped=true&"
import script from "./selectMember.vue?vue&type=script&lang=js&"
export * from "./selectMember.vue?vue&type=script&lang=js&"
import style0 from "./selectMember.vue?vue&type=style&index=0&id=3b96e50a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b96e50a",
  null
  
)

export default component.exports